module.exports = __webpack_public_path__ + "static/media/raspberry_jam.dfcbf1fc.png";